import { Injectable } from '@angular/core';
import { Agreement } from '../domain/Agreement';
import { Service } from '../domain/Service';
import { Account } from '../domain/Account';
import { Payer } from '../domain/Payer';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  clientTenant: any;
  clientTenantName: any;
  clientTenantLogo: any;
  clientPermissions: any[] = [];
  clientAgreements: Agreement[] = [];
  clientServices: Service[] = [];
  clientServices$ = new BehaviorSubject<Service[]>(new Array<Service>());
  clientAccounts: Account[] = [];
  clientAddress?: any;
  clientPayers?: Payer[] = [];
  clientReadyDeadline: any;
  WebAutoReady:boolean = false;
  HeaderTextItem:string;
  countries: [];

  defaultClientPhone?: string;
  defaultClientEmail?: string;
  defaultClientName?: string;
  defaultClientNumber?: string;
  defaultClientContactPerson?: string;
  clientName?: string;
  clientId?: string;
  ClientAllowedToBookOnHoliDay:boolean = false;

  constructor(private readonly _http: HttpClient) {}

  hasClientPermission(permission: any) {
    return this.clientPermissions.includes(permission);
  }

  getInvoices() {
    return this._http.get('/api/e/invoices');
  }

  getInvoiceDocument(invoiceId: string) {
    return this._http.get(`/api/e/invoices/${invoiceId}/document`).pipe(
      map((res: any) => {
        return res.uri;
      })
    );
  }

  SetServicesFromAuthService(cliams:any){
    this.clientServices = cliams;
    this.clientServices$.next(cliams);
  }
}
